module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-thumbs.42db9c36.svg";